var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 207,
    viewBox: "0 0 136 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 207C8.46467 202.023 18.7092 197.766 25.7658 192.157C33.597 185.932 39.8529 176.428 45.5413 168.281C53.1165 157.431 59.734 145.652 68.2455 135.491C80.4421 120.931 97.9331 108.366 116.467 106.295C135 104.225 135 105.258 135 105.258",
    stroke: "#C9C1AE",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136 1C118.271 17.7166 115.061 21.6479 108.046 38.5253C103.84 48.6429 102.517 56.1216 101.178 65.7308C96.6605 98.1466 71.9047 118.374 50.7739 140.997C36.0931 156.715 25 185.329 25 207",
    stroke: "#F5EAD2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLine2);
export default __webpack_public_path__ + "static/media/mLine2.2150f381e1d50c6a83c0708b634fdab4.svg";
export { ForwardRef as ReactComponent };